import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PenLine, ArrowRight } from "lucide-react";
import api, { timeAgo } from "@/lib/api";

export const AuthorsRail = () => {
  const { data } = useQuery({
    queryKey: ["authors-rail"],
    queryFn: async () => (await api.get("/authors-rail")).data,
    staleTime: 5 * 60 * 1000,
  });
  const arts = data?.articles || [];
  if (!arts.length) return null;

  return (
    <section className="mt-14" data-testid="authors-rail">
      <div className="flex items-end justify-between gap-3 mb-5">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A78BFA] flex items-center gap-2">
            <PenLine className="h-3.5 w-3.5" /> NewsLayer Authors
          </p>
          <h2 className="font-heading font-black text-white text-lg md:text-xl mt-1">From Our Authors</h2>
        </div>
        <Link to="/authors" data-testid="authors-rail-all"
          className="font-mono text-[11px] text-[#00E5FF] hover:text-white transition-colors flex items-center gap-1">
          All authors <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {arts.slice(0, 4).map((a: any) => (
          <Link key={a.id} to={`/article/${a.slug}`} data-testid={`authors-rail-card-${a.slug}`}
            className="group rounded-xl border border-white/[0.08] bg-[#0b0c11] overflow-hidden hover:border-[#7C3AED]/50 transition-colors">
            {a.hero_image_url && (
              <div className="aspect-[16/9] overflow-hidden">
                <img src={a.hero_image_url} alt="" loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
              </div>
            )}
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                {a.author?.avatar_url ? (
                  <img src={a.author.avatar_url} alt="" className="h-5 w-5 rounded-full object-cover shrink-0" />
                ) : (
                  <span className="h-5 w-5 rounded-full bg-gradient-to-br from-[#7C3AED] to-[#00E5FF] flex items-center justify-center text-[8px] font-bold text-white shrink-0">
                    {(a.author?.name || "?")[0]}
                  </span>
                )}
                <span className="font-mono text-[10px] text-gray-400 truncate">
                  {a.author?.name}
                  {a.author?.handle && <span className="text-gray-600"> @{a.author.handle}</span>}
                </span>
              </div>
              <h3 className="text-white text-sm font-semibold leading-snug line-clamp-2 group-hover:text-[#00E5FF] transition-colors">
                {a.title}
              </h3>
              <p className="font-mono text-[9px] text-gray-600 mt-2 uppercase">{timeAgo(a.published_at)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
